import { FormattedMessage } from 'react-intl';

import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { DEFAULT_VALUES } from '@/libraries/web-framework/src/localization/values';
const PremiumSupport = () => {
	const localizedHref = useLocalizedHref('/enterprise/support-services');
	return (
		<div>
			<p>
				<FormattedMessage
					id="ConfluencePricingPageTeam24.features.premiumSupport.content.body"
					defaultMessage="Get Premium support around the clock from a dedicated team with 1-hour response times to critical issues. <a>Learn more.</a>"
					values={{
						...DEFAULT_VALUES,
						a: (chunks) => (
							<a
								data-event="clicked"
								data-event-component="linkButton"
								data-product-key="confluence"
								data-label-english="learn more"
								data-track-event="ConfluencePricingPageTeam24.premiumSupport.learnMore"
								data-event-container="ConfluencePriceFinderTeam24"
								href={localizedHref}
							>
								{chunks}
							</a>
						),
					}}
				/>
			</p>
		</div>
	);
};
export default PremiumSupport;
